// @flow
import { Box as RebassBox, Flex as RebassFlex } from 'rebass';

export const Flex = RebassFlex;

export default RebassBox;
